import React from "react";

function SvgIcMapPoi117(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 9a1 1 0 01.993.884L25 10l-.003.414c-.047 3.653-.723 5.472-1.422 7.118l-.306.714c-.648 1.523-1.226 3.098-1.267 6.382L22 25v1h-5v-1c0-4.378 1.722-6.383 3.242-8.152 1.48-1.722 2.758-3.21 2.758-6.847l.007-.117A1 1 0 0124 9zM8 9a1 1 0 011 1l.005.356c.08 3.374 1.324 4.824 2.754 6.493C13.28 18.621 15 20.63 15 25v1h-5v-1c0-3.795-.69-5.403-1.419-7.106-.778-1.813-1.58-3.689-1.58-7.893l.006-.117A1 1 0 018 9zm8-4a4 4 0 110 8 4 4 0 010-8z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi117;
